


















import { Component, Vue } from 'vue-property-decorator';
import { debounce } from 'lodash';
import { namespace } from 'vuex-class';
import { FilterState } from '../../stores/modules/filter';
import { EventBus } from '../../event-bus';

const filter = namespace('filter');
@Component({
  components: {}
})
export default class Name extends Vue {
  private searchIcon: string = 'mdi-cloud-search';
  private input: string | null = null;

  @filter.Mutation('setFilterItem') setFilter!: (a: {
    key: keyof FilterState['filter'];
    val: string | null;
  }) => void;

  mounted() {
    EventBus.$on('reset-filter', () => {
      this.input = null;
    });
    let query: string | FilterState['filter'] = this.$route.query.filter as string;
    if (this.$route.query.filter) {
      query = JSON.parse(query) as FilterState['filter'];
      if (query.wildcard) {
        this.input = query.wildcard;
      }
    }
  }

  debounceInput() {
    const self = this;
    return debounce(function(e: string | null) {
      if (e === '') {
        e = null;
      }
      self.setFilter({ key: 'wildcard', val: e });
    }, 500);
  }
}
